var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, combineLatest, Subject } from 'rxjs';
import { ViewService } from '../../view.service';
import { ViewAudioComponent } from '../view-audio/view-audio.component';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentApplication } from 'src/environments/models/environment-application';
import { ViewState } from '../../state/view.state';
import { StoryState } from 'src/app/story/state/story.state';
import { TextUtils } from 'src/app/shared/libraries/text-utils/text-utils';
export class ViewDescriptionComponent {
    // ---------- Lifecycle ----------
    constructor(viewService, layoutService, changeDetectorRef) {
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Class Variables ----------
        this.viewLayout = ViewLayout;
        this.ngUnsubscribe = new Subject();
        this.storyTitle = '';
        this.chapterTitle = '';
        this.chapterDescription = '';
        this.chapterAudio = null;
        // ---------- Input / Output ----------
        this.layout = 'drawer';
        this._isPopulated = false;
        this.isPopulatedChange = new EventEmitter();
    }
    get isPopulated() {
        return this._isPopulated;
    }
    set isPopulated(value) {
        this._isPopulated = value;
        this.isPopulatedChange.emit(this.isPopulated);
    }
    ngOnInit() {
        this.initContentListener();
        this.initLayoutListener();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    isEnabled(layout) {
        return this.layoutService.isLayoutEnabled(layout);
    }
    // ---------- Listeners ----------
    initContentListener() {
        combineLatest(this.story$, this.chapter$, this.selectedChapterAudio$).pipe(filter(([story, chapter, audio]) => story != null && chapter != null), takeUntil(this.ngUnsubscribe)).subscribe(([story, chapter, audio]) => {
            // Only populate bookmark in web app
            this.storyTitle = (environment.application !== EnvironmentApplication.Viewer) ? TextUtils.normalize(story.displayName) : '';
            this.chapterTitle = TextUtils.normalize(chapter.info.displayName);
            this.chapterDescription = chapter.info.description;
            this.chapterAudio = audio;
            this.isPopulated =
                !!this.storyTitle != null ||
                    !!this.chapterTitle ||
                    !!this.chapterDescription ||
                    this.chapterAudio != null;
        });
    }
    initLayoutListener() {
        this.layout$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((layout) => {
            this.changeDetectorRef.markForCheck();
        });
    }
    // ---------- Interaction ----------
    handlePreviousChapterClick() {
        this.viewService.previousChapter();
    }
    handleNextChapterClick() {
        this.viewService.nextChapter();
    }
    handleAudioPlayClick() {
        if (this.audio.playing) {
            this.audio.pause();
        }
        else {
            this.audio.play();
        }
    }
}
__decorate([
    Select(StoryState.getStory),
    __metadata("design:type", Observable)
], ViewDescriptionComponent.prototype, "story$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapter),
    __metadata("design:type", Observable)
], ViewDescriptionComponent.prototype, "chapter$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapterIndex),
    __metadata("design:type", Observable)
], ViewDescriptionComponent.prototype, "chapterIndex$", void 0);
__decorate([
    Select(StoryChaptersState.getChapterCount),
    __metadata("design:type", Observable)
], ViewDescriptionComponent.prototype, "chapterCount$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapterAudio),
    __metadata("design:type", Observable)
], ViewDescriptionComponent.prototype, "selectedChapterAudio$", void 0);
__decorate([
    Select(ViewState.getLayout),
    __metadata("design:type", Observable)
], ViewDescriptionComponent.prototype, "layout$", void 0);
